import { lazy, Suspense } from "react";
import { Outlet, useParams, Navigate } from "@/lib/router-compat";
import { CountryProvider, useCountry } from "@/hooks/useCountry";
import { Header } from "./Header";
import { MobileBottomNav } from "./MobileBottomNav";
import { WhatsAppButton } from "./WhatsAppButton";
import { isHiddenCountrySlug } from "@/config/countries";

const SiteFooter = lazy(() =>
  import("./SiteFooter").then((m) => ({ default: m.SiteFooter })),
);

function FooterForCountry() {
  const { country, lang } = useCountry();
  return (
    <Suspense fallback={null}>
      <SiteFooter
        countrySlug={country.slug}
        lang={lang}
        whatsappNumber={country.whatsappNumber}
      />
    </Suspense>
  );
}

export function CountryLayout() {
  const { country } = useParams<{ country: string }>();

  if (isHiddenCountrySlug(country)) {
    return <Navigate to="/" replace />;
  }

  // SEO head (title/description/canonical/og/twitter) is owned by the individual
  // route files (src/routes/**) via TanStack's native head() option, so the
  // layout never injects canonical or hreflang tags itself.
  return (
    <CountryProvider>
      <div className="min-h-screen flex flex-col pb-16 md:pb-0 w-full max-w-full">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <FooterForCountry />
        <MobileBottomNav />
        <WhatsAppButton />
      </div>
    </CountryProvider>
  );
}

